import { useState } from 'react'
import {Table, Button} from 'antd'
import dayjs from 'dayjs'
import {Empty, Loader, ProfileCircleIcon} from 'common/components'
import {useGetTransactions, useRemoveTransactions} from '..'
import { useStore, setTransactionPageNumber as setPage } from '../store'
import { PAGE_SIZE } from '../constants'
import styles from './Outlet.module.scss'
import { COLUMNS, /*ROWS*/ } from './mock.transactions'
import { Pagination } from './Pagination'

export default function OutletTransactions() {
  const [selectionStatus, setSelectionStatus] = useState<string>('')
  const [rowKeys, setRowKeys] = useState<string[]>([])
  const page = useStore((state) => state.pageNumberTransaction)
  const {data} = useGetTransactions({ page })
  const {mutate: remove, isMutating} = useRemoveTransactions()

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], rows:any[]) => {
      setRowKeys((selectedRowKeys as string[]) || [])
      setSelectionStatus(rows?.[0]?.status || '')
    },
    getCheckboxProps: (r:any) => ({
      disabled: (!!selectionStatus) && (r.status !== selectionStatus)
    })
  };

  // const rows = ROWS.filter(
  //   (_:any, index:number) => ( (1 + Math.floor(index/PAGE_SIZE)) === page)
  // )
  const rows = data?.data?.map((x:any, index:number) => ({
    key: x.uuid || index,
    date: dayjs(x.date).format('YYYY-MM-DD'),
    spent: (x.amount > 0) ? x.amount : undefined,
    received: (x.amount < 0) ? (-1 * x.amount) : undefined,
    reference: x.type,
    notes: x.notes,
    account: [x.project?.title, x.project?.displayId?.toString()].filter((x:any) => !!x).join(' - '),
    status: !x.xeroStatement ? 'Unreconciled' : 'Reconciled',
  }))
  // console.log(data?.data)

  const count = rowKeys.length ?? 0
  const onRemove = () => {
    if (!count) return
    // console.log(rowKeys)
    remove({
      transactionUuids: rowKeys
    })
  }
  return (
    !data ? (
      <Loader />
    ) : !data.data?.length ? (
      <Empty
        icon={<ProfileCircleIcon width={40} height={40} />}
        title="users"
      />
    ) : (
    <>
      <div className={styles.actions}>
        <Button className={styles.button} onClick={onRemove}
          disabled={!count || isMutating || (selectionStatus !== 'Reconciled')}
        >
          Remove & Redo
        </Button>
        {/* <Button className={styles.button}
          disabled={!count || isMutating}
        >
          Delete
        </Button>
        <Button className={styles.button}
          disabled={(count!==1) || isMutating || (selectionStatus !== 'Unreconciled')}
        >
          Split
        </Button> */}
        <span className={styles.count}>{ count } selected</span>
      </div>

      <Table
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        columns={COLUMNS}
        dataSource={rows}
        pagination={false}
      />
      <Pagination
        showSizeChanger={false}
        current={page}
        total={data?.meta?.total}
        pageSize={PAGE_SIZE}
        onChange={setPage}
      />

    </>
    )
  )
}
